<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <h2 class="text-h5 mb-2" :id="`escola-descricao-${escola.id}`">{{ escola.descricao }}</h2>
        <e-label :id="`label-pesquisa-escola`">Pesquise uma unidade escolar aqui</e-label>
        <v-autocomplete
          :id="`menu_escola.autocomplete_escola`"
          v-model="escola"
          :items="franquiasPermitidas"
          item-text="descricao"
          item-value="id"
          dense
          return-object
          filled
          label="Pesquise uma escola"
        >
          <template v-slot:item="data">
            <!-- data.item = item, data.attrs/data.on traz bindings padrões do autocomplete -->
            <v-list-item
              :id="`menu_escola.franquia_${data.item.id}`"
              v-bind="data.attrs"
              v-on="data.on"
              :key="`menu_escola.item_key_${data.item.id}`"
            >
              <v-list-item-content>
                <v-list-item-title>{{ data.item.descricao }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-tabs v-model="tab" grow background-color="transparent" class="elevation-1 mb-6">
      <v-tab :id="`aba_turmas.tab_turmas`" href="#turmas" class="text-capitalize">
        <v-icon left>groups</v-icon>
        Turmas
      </v-tab>
      <v-tab :id="`aba_relatorios.tab_relatorios`" href="#relatorios" class="text-capitalize">
        <v-icon left>query_stats</v-icon>
        Relatórios
      </v-tab>
      <v-tab :id="`aba_documentos.tab_documentos`" href="#documentos" class="text-capitalize">
        <v-icon left>description</v-icon>
        Documentos
      </v-tab>
      <v-tab :id="`aba_gestao.tab_gestao`" href="#gestao" class="text-capitalize">
        <v-icon left>manage_accounts</v-icon>
        Gestão
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item value="turmas" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_turmas.card_turmas_escola_${escola.id}`"
              color="secondary"
              @click="listarTurmasEscola(escola.id)"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Turmas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual (sem alunos)</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="podeVerDadosGlobais">
            <v-card
              :id="`aba_turmas.card_todas_turmas_sem_alunos`"
              color="secondary"
              @click="listarTodasTurmas()"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >Todas as escolas (sem alunos)</v-card-text
              >
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_turmas.card_alunos_unidades_${escola.id}`"
              color="secondary"
              @click="alunosPorUnidades(escola.id)"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Turmas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="podeVerDadosGlobais">
            <v-card
              :id="`aba_turmas.card_todas_escolas_turmas_com_alunos`"
              color="secondary"
              @click="escolasTurmasAlunos()"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_turmas.card_alunos_especiais_${escola.id}`"
              color="secondary"
              @click="alunosNecessidadesEspeciais(escola.id)"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Relatório de Necessidades Especiais</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_turmas.card_gravidez_na_adolecencia_${escola.id}`"
              color="secondary"
              @click="alunosGravidezAdolescencia(escola.id)"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Relatório de Gravidez na Adolescência</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item value="relatorios" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <v-col cols="12" sm="6" md="4">
            <v-card
              :id="`aba_relatorios.card_relatorio_aulas`"
              color="success"
              @click="insercaoAulas()"
            >
              <v-card-title>
                <v-icon large left>mdi-book-variant</v-icon>
                <span class="title font-weight-light">Relatório aulas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >Relatório inserção de aulas</v-card-text
              >
            </v-card>
          </v-col>

          <!-- Relatório alunos matriculados -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="secondary" @click="alunosMatriculadosXls()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório alunos matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >Relatório alunos matriculados (Planilha)</v-card-text
              >
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" class="pa-4" v-if="podeVerDadosGlobais">
            <v-card
              :id="`aba_relatorios.card_lotacao_geral`"
              color="secondary"
              @click="lotacaoGeral()"
            >
              <v-card-title>
                <v-icon large left>percent</v-icon>
                <span class="title font-weight-light">Relatório de lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_relatorios.card_lotacao_escola_${escola.id}`"
              color="secondary"
              @click="lotacaoEscola(escola.id)"
            >
              <v-card-title>
                <v-icon large left>percent</v-icon>
                <span class="title font-weight-light">Relatório de lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="podeVerDadosGlobais">
            <v-card
              :id="`aba_relatorios.card_lotacao_por_escola_todas_escolas`"
              color="secondary"
              @click="lotacao()"
            >
              <v-card-title>
                <v-icon large left>percent</v-icon>
                <span class="title font-weight-light">Relatório de lotação por escola</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_relatorios.card_movimento_escolar_${escola.id}`"
              color="secondary"
              @click="resumoMovimentoEscolar(escola.id)"
            >
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Resumo movimento escolar</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_relatorios.card_rotas_unidades_${escola.id}`"
              color="secondary"
              @click="relatorioNumeroDeRotas(escola.id)"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Relatório de Rotas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- Aba de Documentos -->
      <v-tab-item value="documentos" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <v-col cols="12" sm="6" md="4">
            <v-card
              :id="`aba_documentos.card_boletins_escola_${escola.id}`"
              color="secondary"
              @click="boletinsFranquia(escola.id)"
            >
              <v-card-title>
                <v-icon large left>receipt_long</v-icon>
                <span class="title font-weight-light">Boletins</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-card
              :id="`aba_documentos.card_relatorios_bncc_escola_${escola.id}`"
              color="success"
              @click="relatoriosBnccFranquia(escola.id)"
            >
              <v-card-title>
                <v-icon large left>child_care</v-icon>
                <span class="title font-weight-light">Relatórios BNCC</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_documentos.card_planos_lancados_escola_${escola.id}`"
              color="secondary"
              @click="relatorioDeListagemDosPlanosLancados(escola.id)"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Relatório de planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="podeVerDadosGlobais && escola && escola.id">
            <v-card
              :id="`aba_documentos.card_planos_lancados_geral`"
              color="secondary"
              @click="relatorioDeListagemDosPlanosLancadosGeral(escola.id)"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Relatório de planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item value="gestao" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_gestao.card_relatorios_evasao_${escola.id}`"
              color="secondary"
              @click="relatoriosEvasao(escola.id)"
            >
              <v-card-title>
                <v-icon large left>flag</v-icon>
                <span class="title font-weight-light">Relatório de Faltas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_gestao.card_relatorios_faltas_professores_${escola.id}`"
              color="secondary"
              @click="OpenModalProfessor()"
            >
              <v-card-title>
                <v-icon large left>flag</v-icon>
                <span class="title font-weight-light">Relatório de Faltas (Professores)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_gestao.card_alunos_nao_matriculados_${escola.id}`"
              color="secondary"
              @click="alunosNaoMatriculados(escola.id)"
            >
              <v-card-title>
                <v-icon large left>edit_off</v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="podeVerDadosGlobais">
            <v-card
              :id="`aba_gestao.card_alunos_nao_matriculados_geral`"
              color="secondary"
              @click="alunosNaoMatriculadosGeral()"
            >
              <v-card-title>
                <v-icon large left>edit_off</v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_gestao.card_alunos_remanejados_${escola.id}`"
              color="secondary"
              @click="alunosRemanejados(escola.id)"
            >
              <v-card-title>
                <v-icon large left>swap_horiz</v-icon>
                <span class="title font-weight-light">Alunos Remanejados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="podeVerDadosGlobais">
            <v-card
              id="aba_gestao.card_alunos_remanejados_geral"
              color="secondary"
              @click="alunosRemanejadosGeral()"
            >
              <v-card-title>
                <v-icon large left>swap_horiz</v-icon>
                <span class="title font-weight-light">Alunos Remanejados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="6"
            v-if="podeVerDadosGlobais && escola && escola.id"
          >
            <v-card
              :id="`aba_gestao.card_professores_por_disciplina`"
              color="secondary"
              @click="qtdProfessoresPorDisciplina()"
            >
              <template slot="progress">
                <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> group </v-icon>
                <span class="title font-weight-light">Professores por disciplina</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="4">
            <v-card
              :id="`aba_gestao.card_relatorios_censo_escola_${escola.id}`"
              color="success"
              @click="relatoriosCensoFranquia(escola.id)"
            >
              <template slot="progress">
                <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório Por escola (Censo)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6" lg="4" v-if="podeVerDadosGlobais">
            <v-dialog v-model="mesUsoDoSistema" width="500">
              <template v-slot:activator="{ on, attrs }">
                <!-- @click="relatoriosUsoDoSistema(mes, escola.id)" -->
                <v-card
                  :id="`aba_gestao.card_relatorios_uso_do_sistema_${escola.id}`"
                  v-bind="attrs"
                  v-on="on"
                  color="success"
                >
                  <template slot="progress">
                    <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
                  </template>
                  <v-card-title>
                    <v-icon large left> mdi-account-search </v-icon>
                    <span class="title font-weight-light">Relatório de Uso do Sistema</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
                </v-card>
                <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on"> Click Me </v-btn> -->
              </template>

              <v-card>
                <v-card-title class="text-h5 grey primary">
                  Escolha o mês do relatório</v-card-title
                >

                <v-card-text class="text-center mt-6">
                  <v-btn-toggle
                    v-model="mesUsoDoSistema"
                    v-for="mes in $constants.meses"
                    :key="mes.id"
                  >
                    <v-btn
                      :id="`aba_gestao.btn_modal_relatorio_uso_mes_${mes.id}_escola_${escola.id}`"
                      @click="relatoriosUsoDoSistema(mes.id, escola.id)"
                      :value="mes"
                    >
                      {{ mes.descricao }}
                      <!-- <v-icon>mdi-format-align-left</v-icon> -->
                    </v-btn>
                  </v-btn-toggle>
                </v-card-text>

                <v-divider></v-divider>
              </v-card>
            </v-dialog>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6" lg="4" v-if="podeVerDadosGlobais">
            <v-dialog v-model="modalSelecaoMes" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  id="aba_gestao.card_relatorios_movimentacao_matricula"
                  v-bind="attrs"
                  v-on="on"
                  color="success"
                >
                  <template slot="progress">
                    <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
                  </template>
                  <v-card-title>
                    <v-icon large left> mdi-account-search </v-icon>
                    <span class="title font-weight-light">Movimentações de Matrículas</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
                </v-card>
                <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on"> Click Me </v-btn> -->
              </template>

              <v-card>
                <v-card-title class="text-h5 grey primary">
                  Escolha o mês do relatório</v-card-title
                >

                <v-card-text class="text-center mt-6">
                  <v-btn-toggle
                    v-model="mesMovimentacaoMatricula"
                    v-for="mes in $constants.meses"
                    :key="mes.id"
                  >
                    <v-btn
                      :id="`aba_gestao.btn_modal_relatorio_movimentacao_mes_${mes.id}`"
                      @click="relatoriosMovimentacaoMatricula(mes.id)"
                      :value="mes"
                    >
                      {{ mes.descricao }}
                    </v-btn>
                  </v-btn-toggle>
                </v-card-text>

                <v-divider></v-divider>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    <template v-if="dialogProfessor">
      <v-row justify="center">
        <v-dialog v-model="dialogProfessor" max-width="450">
          <v-card>
            <v-card-title class="text-h5">Selecione o mês correspondente</v-card-title>
            <v-card-text>
              <v-row justify="center" class="mt-4">
                <v-date-picker
                  :id="`aba_gestao.picker_relatorios_evasao_professor_${escola.id}`"
                  v-model="picker"
                  type="month"
                ></v-date-picker>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :id="`aba_gestao.btn_relatorios_evasao_professor_${escola.id}`"
                color="green darken-1"
                text
                @click="relatoriosEvasaoProfessor(escola.id)"
              >
                Gerar Relatório
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <e-modal-boletim-franquia
      :dialog="dialogBoletimFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogBoletimFranquia = $event"
    ></e-modal-boletim-franquia>

    <e-modal-bncc-franquia
      :dialog="dialogBnccFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogBnccFranquia = $event"
    ></e-modal-bncc-franquia>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import useRoleCheck from "@/composables/useRoleCheck";
import { $constants } from "../../plugins/constants";

export default {
  name: "Relatórios",
  setup() {
    const { podeVerDadosGlobais } = useRoleCheck();
    return { podeVerDadosGlobais };
  },
  data() {
    return {
      tab: null, // Controle da aba ativa
      dialogProfessor: false,
      dialogBoletimFranquia: false,
      dialogBnccFranquia: false,
      picker: new Date().toISOString().substr(0, 7),
      escola: {
        descricao: null,
        id: null,
      },
      franquia_id: null,
      modalSelecaoMes: false,
      mesUsoDoSistema: null,
      mesSelecionadoUsoDoSistema: new Date().toISOString().substr(0, 7),
      mesMovimentacaoMatricula: null,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquiasList", "carregandoFranquias"]),
    franquiasPermitidas() {
      if (!this.user || !this.franquiasList) return [];

      // Se não há restrição de franquias_permitidas, retorna todas
      if (!this.user.franquias_permitidas || this.user.franquias_permitidas.length === 0) {
        return this.franquiasList.filter((franq) => !franq.deleted_at);
      }

      // Filtra apenas as franquias permitidas para o usuário
      return this.franquiasList.filter((franq) => {
        return !franq.deleted_at && this.user.franquias_permitidas.includes(franq.id);
      });
    },
  },
  methods: {
    async alunosPorUnidades(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosPorUnidadeEScolar(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async alunosNecessidadesEspeciais(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNecessidadesEspeciais(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async alunosGravidezAdolescencia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosGravidezAdolescencia(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatorioNumeroDeRotas(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioNumeroDeRotas(parseInt(franquia_id, 10));
      } catch (error) {
        if (
          error.message &&
          error.message !== "Nenhum registro encontrado para o item pesquisado."
        ) {
          this.$toast.danger(error.message);
        } else {
          this.$toast.danger("Não foi possível gerar o relatório. Tente novamente!");
        }
      }
      this.$loaderService.close();
    },
    async lotacaoGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async lotacao() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacao();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async lotacaoEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoEscola(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async boletinsFranquia(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.dialogBoletimFranquia = !this.dialogBoletimFranquia;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatoriosBnccFranquia(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.dialogBnccFranquia = !this.dialogBnccFranquia;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatoriosBnccFranquiaAntigo(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosBnccFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$toast.danger("Não encontramos turmas de infantil vinculado a essa escola!");
      }
      this.$loaderService.close();
    },

    async escolasTurmasAlunos() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.escolasTurmasAlunos();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async listarTodasTurmas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTodasTurmas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async listarTurmasEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTurmasFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async insercaoAulas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.insercaoAulas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async resumoMovimentoEscolar(fraquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.resumoMovimentoEscolar(fraquia_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatorioDeListagemDosPlanosLancados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancados(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatorioDeListagemDosPlanosLancadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatoriosEvasao(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosEvasao(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    OpenModalProfessor() {
      this.dialogProfessor = true;
    },

    async relatoriosEvasaoProfessor(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        const picker = this.picker;
        const dataSemTraco = picker.replace(/-/g, "");
        await this.$services.relatoriosService.relatoriosEvasaoProfessor(
          parseInt(franquia_id, 10),
          dataSemTraco
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async alunosNaoMatriculados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculados(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async alunosNaoMatriculadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async alunosRemanejados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosRemanejados(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async alunosRemanejadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosRemanejadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async qtdProfessoresPorDisciplina() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.qtdProfessoresPorDisciplina();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatoriosCensoFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosCensoFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatoriosUsoDoSistema(mes, franquia_id) {
      this.modalSelecaoMes = false;
      this.mesUsoDoSistema = null;
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosUsoDoSistema(
          mes,
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$toast.danger("Você não tem permissão para acessar esse Recurso!");
      }
      this.$loaderService.close();
    },
    async relatoriosMovimentacaoMatricula(mes) {
      this.modalSelecaoMes = false;
      this.mesMovimentacaoMatricula = null;
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosMovimentacaoMatricula(mes);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async alunosMatriculadosXls() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosMatriculadosXls();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
  mounted() {
    this.$loaderService.open("Carregando dados...");
    this.escola = this.user.franquia;
    this.$loaderService.close();
  },
};
</script>

<style scoped>
.v-card {
  height: 100%;
  transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 8px !important;
  overflow: hidden;
  border-left: 4px solid transparent;
}

.v-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.08) !important;
}

.v-card.secondary {
  border-left-color: var(--v-secondary-base);
  background: linear-gradient(to right, #fff7e4, #ffffff);
}

.v-card.success {
  border-left-color: var(--v-success-base);
  background: linear-gradient(to right, #f0fff0, #ffffff);
}

.v-tabs {
  border-radius: 8px;
}

.v-tab {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.v-tab--active {
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.062);
}

.v-tab-item {
  padding: 8px 0;
}

.v-col {
  padding-bottom: 16px;
  padding-top: 8px;
}

@media (max-width: 960px) {
  .v-card__title {
    font-size: 1rem !important;
    padding: 12px !important;
  }

  .v-card__text {
    font-size: 0.875rem !important;
    padding: 0 12px 12px !important;
  }

  .v-tab {
    font-size: 0.75rem;
    min-width: auto;
    padding: 0 12px;
  }

  .v-tab .v-icon {
    font-size: 1.25rem !important;
    margin-right: 4px !important;
  }
}

.v-card:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: currentColor;
  opacity: 0;
  transition: opacity 0.3s;
}

.v-card:hover:before {
  opacity: 0.04;
}

.v-autocomplete {
  border-radius: 8px;
  overflow: hidden;
}

.v-row:not(:last-child) {
  margin-bottom: 16px;
}
</style>
